export default function getBoundingBox(points) {
  try {
    if (points.length === 0) {
      throw new Error("No points provided");
    }
    let minLat = points[0].from.coordinates[1];
    let minLng = points[0].from.coordinates[0];
    let maxLat = points[0].from.coordinates[1];
    let maxLng = points[0].from.coordinates[0];

    points.forEach(point => {
      minLat = Math.min(minLat, point.to.coordinates[1]);
      minLng = Math.min(minLng, point.to.coordinates[0]);
      maxLat = Math.max(maxLat, point.to.coordinates[1]);
      maxLng = Math.max(maxLng, point.to.coordinates[0]);
    });

    const centerLat = (minLat + maxLat) / 2;
    const centerLng = (minLng + maxLng) / 2;

    return {
      minLat,
      minLng,
      maxLat,
      maxLng,
      center: {
        lat: centerLat,
        lng: centerLng
      }
    };
  } catch (error) {
    // console.log("Error in getBoundingBox.ts:", error);
  }
}
